import React from 'react';
import { Button } from 'antd';
import s from './s.module.less';
import { ServerMeta } from 'types/common';
import { TMedicationContent } from 'pages/operation/MedicationListPageManagement/type';

interface ContentItemProps {
    content?: TMedicationContent;
    condition?: ServerMeta;
    onEdit: () => void;
}

const MedicationContentItem: React.FC<ContentItemProps> = ({
    content,
    condition,
    onEdit,
}) => {
    return (
        <div className={s.contentItem}>
            <div className={s.header}>
                <h3 className={s.title}>{condition?.content}</h3>
                <Button
                    onClick={onEdit}
                >
                    Edit
                </Button>
            </div>

            <div className={s.content}>
                <div className={s.dataBlock}>
                    <div className={s.dataLabel}>Title</div>
                    <div className={s.dataValue}>{content?.title}</div>
                </div>

                <div className={s.dataBlock}>
                    <div className={s.dataLabel}>Subtext</div>
                    <div className={s.dataValue}>{content?.subText}</div>
                </div>
            </div>
        </div>
    );
};

export default MedicationContentItem;
